export default "__VITE_ASSET__DzCj$uIs__"